import React from 'react';
import Assets from '../../Assets/Assets';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import Appcontent from './Appcontent';


function DefaultLayout() {
    const menuItems = [
        { name: 'Dashboard', link: '/', icon: '🏠' },
        { name: 'Courses', link: '/university', icon: '🎓' },
        { name: 'Wallet', link: '/wallet', icon: '💳' },
        { name: 'Reports', link: '/reports', icon: '📈' },
        { name: 'Payments History', link: '/payments', icon: '💰' },
        { name: 'Account', link: '/account', icon: '👤' },
   
        { name: 'Logout', link: '/logout', icon: '🚪' },
    ];
    return (
        <div className="dashboard-layout">
            <Sidebar menuItems={menuItems} logo={Assets?.Logo} />
            <div className="main-content">
                <Header
                    logo={Assets?.Logo}
                    userName="John Doe"
                    profilePhoto={Assets?.Login_b}
                />
                <div className="contents" style={{ textAlign: "start", paddingLeft: "19%", paddingTop: "6%" }}>
                    <Appcontent />
                </div>
            </div>
        </div>
    );
}

export default DefaultLayout;
